import type { Character } from "@cloudnest/horror-race-engine";
import { RaceBoardView } from "./board/RaceBoardView";

interface RaceTrackProps {
  readonly positions: Readonly<Record<Character, number>>;
  readonly trackLength: number;
}

// The in-game race track: 5 FIXED lanes (one per character) over the physical
// cadence ruler (출발 · 1..N grouped in 4s · 골인). Shared board rendering lives
// in <RaceBoardView> (reused by the recap screens); this wrapper only adds the
// in-game chrome.
//
// Compact (T21): a borderless band (top/bottom rule only, edge-to-edge) that
// fits the screen width (cells are `minmax(0, 1fr)` → no horizontal scroll).
// Static display — no tap-to-expand detail view.
export function RaceTrack({ positions, trackLength }: RaceTrackProps) {
  return (
    <div
      data-testid="horror-track"
      className="px-1 py-2"
      style={{
        backgroundColor: "var(--cn-horror-card-bg)",
        borderTop: "1px solid var(--cn-horror-surface-border)",
        borderBottom: "1px solid var(--cn-horror-surface-border)",
      }}
    >
      <RaceBoardView positions={positions} trackLength={trackLength} />
    </div>
  );
}
